import { Component } from "react";
import { DKLabel, DKButton, DKInput, showLoader, removeLoader, showToast, TOAST_TYPE, DKIcons, DKLine, DKRadioButton, INPUT_VIEW_DIRECTION, DKTooltipWrapper, DKIcon } from "deskera-ui-library";

import Utility, { deepClone } from "../../../../utility/Utility";

import ReportService from "../../../../services/ReportService";
import { saveAs } from 'file-saver';

import { IRASSummaryReportForm, SG_CONSTANT } from "./SGReportsConstant";
import { INPUT_TYPE } from "../../../../constants/Constant";
import RouteManager, { PAGE_ROUTES } from "../../../../managers/RouteManager";
import DataGridHolderPayroll from "../../../common/DataGridHolderPayroll";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../../../managers/TableManger";
import { irasReportGenerate, parseColumnConfig, parseVisibleColumnConfig } from "../../../configs/config";
import ApiConstants from "../../../../constants/ApiConstants";
import ic_arrow_back from "../../../../assets/icons/ic_arrow_back.svg";
import IR8AForm from "./IR8AForm";
import { connect } from "react-redux";
import { deleteFormEmployeeDetails } from "../../../../Redux/Slices/SGFormsSlice"
class IRASSummaryReport extends Component {
    MYReportForm = deepClone(IRASSummaryReportForm)
    
    defaultValues = {
        year: new Date().getFullYear(),
        status: SG_CONSTANT.status.READY_FOR_SUBMISSION,
        format: 'XLS',
        limit: 20,
        currentPage: 0,
        sortOrder: 'desc',
        sortField: 'updatedAt'
    }
    grid = {
        gridActions: {
            filters: [],
            currentPage: 1,
            totalPageCount: 1
        },
        gridData: {

            columnData: parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_IRAS_SUMMARY_REORT), TABLES.PEOPLE_IRAS_SUMMARY_REORT)),
            rowData: [],
            filter: [],
            originalData: []
        },
        canValidate: false,
        editIR8A : false,
        ir8ADetails:{}
    }
    constructor(props) {
        super(props);
        RouteManager.setPresenter(this);

    }
    componentDidMount() {
        this.updateState();
    }
    updateState() {
        this.setState({
            ...this.state
        })
    }
    getFieldValue(obj) {
        if (obj.options && obj.options.length != 0) {
            if (obj.options[0].id) {
                return obj.options.find(o => o.id == this.defaultValues[obj.key])
            } else {
                return obj.options.find(o => o == this.defaultValues[obj.key])
            }
        }
        return this.defaultValues[obj.key];
    }

    onChange(value, index, obj) {
        this.defaultValues[obj.key] = (value && value.id) ? value.id : value
    }
    renderFormField(obj, index) {
        return (
            <>
                {obj.type != INPUT_TYPE.RADIO_BUTTON && <DKInput

                    className={"p-v-s mb-r m-h-m "}
                    icon={obj.icon}
                    title={obj.name}
                    placeholder={obj.name}
                    value={this.getFieldValue(obj)}
                    options={obj.options}
                    type={obj.type}
                    errorMessage={obj.errorMessage}
                    labelClassName=" text-align-left "
                    canValidate={this.canValidate}
                    onChange={(value) => {
                        this.onChange(value, index, obj);
                    }}
                    validator={(value) => {
                        if (obj.validation && obj.validation.regExp) {
                            const regex = new RegExp(obj.validation.regExp);
                            obj.isValid = regex.test(value);
                            return regex.test(value);
                        } else if (obj.required && typeof value === "string" && Utility.isEmpty(value.trim())) {
                            obj.isValid = false
                            return false;
                        } else if (obj.required && Utility.isEmpty(value)) {
                            obj.isValid = false
                            return false;
                        } else {
                            obj.isValid = true;
                            return true;
                        }
                    }}
                    formatter={(obj) => {
                        /** How to render a selected option in case of object **/
                        return (obj && obj.name) ? obj.name : obj;
                    }}
                    dropdownConfig={{
                        className: "",
                        style: {},

                        data: obj.options,
                        renderer: (index, obj) => {
                            /** How to render value in Dropdown in case of object **/
                            return <DKLabel text={`${((obj && obj.name) ? obj.name : obj)}`} />;
                        },
                        onSelect: (index, obj) => {

                        },
                    }}
                    direction={obj.direction}
                    required={obj.required}
                    readOnly={obj.readOnly}
                />}
                {obj.type == INPUT_TYPE.RADIO_BUTTON &&
                    (
                        <div className="pb-l p-h-xxl ml-s parent-height pt-s">
                            <DKLabel className={`row mb-m `} text={obj.name} />
                            <div className={`row  `}>

                                {obj.options.map(radio => {
                                    return (
                                        <>
                                            <div className="row" style={{ width: "auto" }}>
                                                <DKRadioButton
                                                    isSelected={
                                                        this.defaultValues[obj.key] ==
                                                        radio.id
                                                    }
                                                    color="bg-app"
                                                    onClick={() => {
                                                        this.defaultValues[obj.key] = radio.id;
                                                        this.updateState()
                                                    }}
                                                />
                                                <DKLabel
                                                    className="ml-s mr-l"
                                                    text={radio.name}
                                                />
                                            </div>
                                        </>
                                    )
                                })}

                            </div>
                        </div>)
                }
            </>
        )
    }
    onButtonClick(btn) {
        let param = {
            ...this.defaultValues,
            "module": 'IRAS_SUMMARY_REPORT',
            'searchString': 'undefined'
        }
        if (param['submissionMedia']) {
            param['submission-media'] = param['submissionMedia']
        }
        showLoader()
        ReportService.getComponentReport(param).then(response => {
            removeLoader()
            saveAs(response, `IRAS Summary Report${this.defaultValues['format'] == 'XLS' ? ".xlsx" : ""}`);

        }, error => {
            removeLoader()
            showToast("Unable to download", TOAST_TYPE.FAILURE)
        })

    }
    generateReport() {
        showLoader()
        let param = {
            year: this.defaultValues['year'],
            limit: this.defaultValues['limit'],
            currentPage: this.defaultValues['currentPage'],
            sortField: this.defaultValues['sortField'],
            sortOrder: this.defaultValues['sortOrder'],
            'searchString': 'undefined',
            reportType: 'IR8A'

        }
        ReportService.getComponentGenerateReport(param).then(res => {
            removeLoader()
            if (res && res['reportSummaries']) {


                if (res['reportSummaries'].length == 0) {
                    showToast('No IRAS Summary Reports Found.')
                }
                this.grid.gridData.rowData = irasReportGenerate(res['reportSummaries'])
                this.updateState()
            }


        }, error => {
            removeLoader()
            showToast('No IRAS Summary Reports Found.')
        })
    }
    getButtons(btn) {
        return (
            <DKButton title={"DOWNLOAD REPORT"} icon={DKIcons.white.ic_import} className="bg-app text-white border-m m-s" onClick={() => this.onButtonClick(btn)} />
        )
    }

    routeToOrigin = () => {
        RouteManager.navigateToPage(PAGE_ROUTES.REPORTS_LIST);
    }
    
    onRowClick = (data) => {
        if(data?.rowData?.totalData) {
            const userData = data?.rowData?.totalData;
            this.editIR8A = true;
            this.ir8ADetails = {userId: userData.employeeId, formDetails: [userData] }
            this.updateState();
        }
    }

    closeIR8AForm = () => {
        this.props.deleteFormEmployeeDetails().then((response) => {
            this.editIR8A = false;
            this.ir8ADetails = [];
            this.generateReport();
            this.updateState();
        });
    }

    getGiroGrid = () => {
        return (
            <div className="column parent-width flex-1 ">
                <div className="column parent-width mb-s position-relative flex-1 ">
                    <DataGridHolderPayroll
                        tableName={TABLES.PEOPLE_IRAS_SUMMARY_REORT}
                        displayTableName={" "}
                        allowColumnEdit={false}
                        allowColumnDelete={false}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={false}
                        allowColumnAdd={false}
                        allowRowAdd={false}
                        allowColumnSort={false}
                        refresh={false}
                        allowDataExport={false}
                        allowRowEdit={true}
                        showContextEdit={false}
                        isActionEnabled={true}
                        contextMenu={false}
                        isMenuVisible={false}
                        showContextMenu={false}
                        gridData={this.grid.gridData}
                        filter={this.grid.gridActions.filters}
                        currentPage={this.grid.gridActions.currentPage}
                        totalPageCount={this.grid.gridActions.totalPageCount}
                        addButtonConfig={[

                        ]}
                        onRowOpenBtnHidden={false}
                        onFilter={(dataList, queries) => {

                        }}
                        onRowUpdate={(data) => {
                            this.onRowUpdate(data);
                        }}
                        onRowDelete={(data) => {
                            this.onRowDelete(data)
                        }}
                        onPaginationClick={(requestedPageNumber) => {

                        }}
                        onSelection={(selection) => {
                            this.selection = (selection);
                        }}
                        allowBulkOperation={true}
                        dateFormat={this.dateFormat}

                        onCancelContext={() => {
                            this.onContextCancel();
                        }}
                        contextMenu={false}
                        // onRowClick={(data) => {
                        //     this.onRowClick(data)
                        // }}
                        onPaginationClick={(requestedPageNumber) => {
                            this.grid.gridActions.currentPage = requestedPageNumber
                            this.generateReport()
                        }}
                        onSearch={(data) => this.onSearch(data)}
                        onRowEdit={(data) => {
                            this.onRowClick(data);
                        }}
                    />
                </div>
            </div>
        )
    }
    render() {
        return (
            <>
                <div className="row" onClick={() => this.routeToOrigin()}>
                    <DKTooltipWrapper
                        content="Back to Report list"
                        tooltipClassName="warning-tooltip-prop"
                    >
                        <DKIcon src={ic_arrow_back} className="ic-s mr-r cursor-hand" />
                    </DKTooltipWrapper>
                    <DKLabel className="fw-m fs-l" text="IRAS Summary Report" />
                </div>
                <div className="parent-width bg-white border-m mt-l">
                    <DKLabel text="Generate IRAS Summary Report" className="m-l fw-m fs-l" />
                    <DKLine className="bg-gray3 mb-s" />
                    <div className="d-flex p-m">
                        {this.MYReportForm.map((field, index) => {
                            return <div className="web-width-50 pr-xl">{this.renderFormField(field, index)}</div>
                        })}
                        <DKButton title={"GENERATE REPORT"} disabled={this.defaultValues.status == SG_CONSTANT.status.SUBMITTED} className={` ${this.defaultValues.status == SG_CONSTANT.status.SUBMITTED ? "bg-gray1 ":"bg-app text-white"}  border-m m-xl`} onClick={() => this.generateReport()} />
                    </div>
                    <div className="d-flex p-m">
                        {this.getButtons()}
                    </div>
                </div>
                {
                    this.getGiroGrid()
                }
                {this.editIR8A && <IR8AForm onClose={(action) => this.closeIR8AForm()} data={this.ir8ADetails}  />}
            </>
        )
    }
}

const mapDispatchToProps = { deleteFormEmployeeDetails };

export default connect(null, mapDispatchToProps)(IRASSummaryReport)
